"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUserHoldingViewMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class UpdateUserHoldingViewMapper {
    toDomain(result) {
        const id = lodash_1.default.get(result, "data.updateUserHoldingView.id");
        return {
            id,
        };
    }
}
exports.UpdateUserHoldingViewMapper = UpdateUserHoldingViewMapper;
